(function () {
  'use strict';
  if (window.__christmasThemeLoaded) return;
  window.__christmasThemeLoaded = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sliders = new Map(), revealObserver, lastTrigger;
  function initSlider(slider) {
    if (sliders.has(slider) || !('IntersectionObserver' in window) || !('ResizeObserver' in window)) return;
    var viewport = slider.querySelector('.vesso-slider-viewport');
    if (!viewport) return;
    var track = slider.querySelector('.vesso-slider-track');
    if (track.animate && !reduced.matches) slider.classList.add('ch-slider-enhanced');
    var group = track.children[0], duplicate = track.children[1];
    var pause = slider.querySelector('[data-ch-pause]');
    var status = slider.querySelector('[data-ch-status]');
    var animation, width = 0, inView = false, stopped = false, hovered = false, focused = false;
    var timer, dragClickTimer, loading = false, failed = false, destroyed = false, drag = null;
    var controller = new AbortController(), speed = 28;
    var visited = new Set();
    var seen = new Set(Array.from(group.children).map(function (c) { return c.dataset.chProduct; }));
    function sync() {
      if (animation) {
        if (!stopped && inView && !hovered && !focused && !document.hidden && !reduced.matches) animation.play();
        else animation.pause();
      }
      pause.textContent = stopped || reduced.matches ? (slider.dataset.playLabel || 'Play') : (slider.dataset.pauseLabel || 'Pause');
      pause.setAttribute('aria-pressed', String(stopped || reduced.matches));
      pause.disabled = reduced.matches;
      pause.title = reduced.matches ? 'Automatic motion is disabled by your device preference. Use the arrows or scroll.' : '';
    }
    function measure() {
      if (destroyed) return;
      var newWidth = group.getBoundingClientRect().width;
      if (newWidth <= 0) return;
      var offset = animation && width ? (Number(animation.currentTime || 0) * speed / 1000) % width : 0;
      width = newWidth;
      if (animation) animation.cancel();
      animation = null;
      if (track.animate && !reduced.matches && group.children.length > 1) {
        animation = track.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-' + width + 'px)' }], { duration: width / speed * 1000, iterations: Infinity, easing: 'linear' });
        animation.currentTime = offset / speed * 1000;
      }
      sync();
    }
    function move(pixels) {
      stopped = true;
      if (animation && width) {
        var duration = width / speed * 1000;
        animation.currentTime = ((Number(animation.currentTime || 0) + pixels / speed * 1000) % duration + duration) % duration;
      } else viewport.scrollBy({ left: pixels, behavior: reduced.matches ? 'auto' : 'smooth' });
      sync();
    }
    pause.addEventListener('click', function () { stopped = !stopped; sync(); });
    slider.querySelector('[data-ch-prev]').addEventListener('click', function () { move(-viewport.clientWidth * .72); });
    slider.querySelector('[data-ch-next]').addEventListener('click', function () { move(viewport.clientWidth * .72); });
    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move((event.key === 'ArrowRight' ? 1 : -1) * viewport.clientWidth * .65); }
    });
    viewport.addEventListener('pointerdown', function (event) {
      // A mouse press on a product link is native navigation, not a carousel drag.
      // Clear only stale drag suppression; keyboard and modified link clicks stay native.
      if (event.pointerType === 'mouse' && event.target.closest('a,button')) {
        clearTimeout(dragClickTimer);
        delete viewport.dataset.dragged;
        drag = null;
        return;
      }
      if (!animation || (event.pointerType === 'mouse' && event.button !== 0)) return;
      drag = { x: event.clientX, y: event.clientY, time: Number(animation.currentTime || 0), moved: false };
      stopped = true; sync();
    });
    viewport.addEventListener('pointermove', function (event) {
      if (!drag || !animation) return;
      var dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      if (!drag.moved && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { drag = null; return; }
      if (Math.abs(dx) > 7) {
        drag.moved = true;
        var duration = width / speed * 1000;
        animation.currentTime = ((drag.time - dx / speed * 1000) % duration + duration) % duration;
      }
    }, { passive: true });
    function endDrag() {
      if (drag && drag.moved) {
        viewport.dataset.dragged = 'true';
        clearTimeout(dragClickTimer);
        dragClickTimer = setTimeout(function () { delete viewport.dataset.dragged; }, 100);
      }
      drag = null;
    }
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);
    viewport.addEventListener('click', function (event) { if (viewport.dataset.dragged) { event.preventDefault(); event.stopPropagation(); } }, true);
    slider.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovered = true; sync(); } });
    slider.addEventListener('pointerleave', function () { hovered = false; sync(); });
    viewport.addEventListener('focusin', function (event) {
      focused = true; stopped = true;
      var card = event.target.closest('.vesso-product-card');
      if (card && animation) {
        var bounds = card.getBoundingClientRect(), frame = viewport.getBoundingClientRect();
        if (bounds.left < frame.left || bounds.right > frame.right) { viewport.scrollLeft = 0; animation.currentTime = card.offsetLeft / speed * 1000; }
      }
      sync();
    });
    viewport.addEventListener('focusout', function () { setTimeout(function () { focused = viewport.contains(document.activeElement); sync(); }, 0); });
    var imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.loading = 'eager'; imageObserver.unobserve(entry.target); } });
    }, { root: viewport, rootMargin: '0px 500px' });
    function watchImages() { slider.querySelectorAll('img[loading="lazy"]').forEach(function (img) { imageObserver.observe(img); }); }
    function schedule() {
      clearTimeout(timer);
      if (!destroyed && inView && !document.hidden && !failed && slider.querySelector('[data-ch-next-page]')) timer = setTimeout(loadNext, 1400);
    }
    async function loadNext(event) {
      if (event) event.preventDefault();
      var link = slider.querySelector('[data-ch-next-page]');
      if (!link || loading || destroyed) return;
      loading = true; failed = false;
      link.setAttribute('aria-busy', 'true');
      status.textContent = slider.dataset.loadingLabel || 'Finding more little wonders…';
      try {
        var url = new URL(link.href, location.origin);
        if (url.origin !== location.origin) throw new Error('Unexpected product source');
        url.searchParams.set('section_id', slider.dataset.section);
        var preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        if (visited.has(url.href)) throw new Error('Repeated product page');
        var response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Unable to load the next product page');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var incoming = doc.querySelector('[data-ch-slider] .vesso-slider-group');
        if (!incoming) throw new Error('Product group missing');
        var fragment = document.createDocumentFragment(), cloneFragment = document.createDocumentFragment(), added = 0;
        Array.from(incoming.children).forEach(function (card) {
          var id = card.dataset.chProduct;
          if (card.tagName !== 'ARTICLE' || !id || seen.has(id)) return;
          seen.add(id); added++;
          var copy = card.cloneNode(true);
          copy.querySelectorAll('button').forEach(function (b) { b.remove(); });
          copy.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
          copy.querySelectorAll('img').forEach(function (img) { img.alt = ''; });
          fragment.appendChild(card); cloneFragment.appendChild(copy);
        });
        if (!added) throw new Error('No new products returned');
        group.appendChild(fragment); duplicate.appendChild(cloneFragment); visited.add(url.href);
        var next = doc.querySelector('[data-ch-next-page]');
        if (next) { link.href = next.getAttribute('href'); link.removeAttribute('aria-busy'); }
        else link.remove();
        status.textContent = (slider.dataset.loadedLabel || '{count} products ready to explore.').replace('{count}',String(seen.size));
        measure(); watchImages();
      } catch (error) {
        if (error.name !== 'AbortError') {
          failed = true;
          status.textContent = slider.dataset.errorLabel || 'More products are available. Select “Load more” to retry or shop the full collection.';
          link.removeAttribute('aria-busy');
        }
      } finally { loading = false; schedule(); }
    }
    slider.addEventListener('click', function (event) { if (event.target.closest('[data-ch-next-page]')) loadNext(event); });
    var observer = new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; sync(); schedule(); }, { rootMargin: '150px' });
    observer.observe(slider); watchImages();
    var resize = new ResizeObserver(measure); resize.observe(group); measure();
    function visibility() { sync(); schedule(); }
    function motion() { slider.classList.toggle('ch-slider-enhanced', !!track.animate && !reduced.matches); measure(); }
    document.addEventListener('visibilitychange', visibility);
    reduced.addEventListener('change', motion);
    sliders.set(slider, function () {
      destroyed = true; clearTimeout(timer); clearTimeout(dragClickTimer); controller.abort(); observer.disconnect(); imageObserver.disconnect(); resize.disconnect();
      if (animation) animation.cancel();
      document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', motion);
    });
  }
  function init(root) {
    root = root || document;
    sliders.forEach(function (cleanup, element) { if (!element.isConnected) { cleanup(); sliders.delete(element); } });
    root.querySelectorAll('[data-ch-slider]').forEach(initSlider);
    if (!(window.Shopify && window.Shopify.designMode) && !reduced.matches && 'IntersectionObserver' in window) {
      if (!revealObserver) revealObserver = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('ch-revealed'); revealObserver.unobserve(entry.target); } }); }, { threshold: .08 });
      document.documentElement.classList.add('ch-reveal-ready');
      root.querySelectorAll('.ch-scene-card,.ch-section-heading,.ch-atmosphere-copy,.ch-spotlight-copy,.ch-guide-layout>div').forEach(function (element) { element.dataset.chReveal = ''; revealObserver.observe(element); });
    }
    var countdown = document.querySelector('[data-ch-countdown]');
    if (countdown) {
      var now = new Date(), target = new Date(now.getFullYear(), 11, 25);
      if (now.getMonth() === 11 && now.getDate() === 25) { countdown.querySelector('[data-ch-days]').textContent = 'Merry Christmas'; countdown.querySelector('[data-ch-countdown-label]').textContent = 'A little joy, wherever you are.'; }
      else {
        if (now > target) target = new Date(now.getFullYear() + 1, 11, 25);
        var start = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
        var finish = Date.UTC(target.getFullYear(), target.getMonth(), target.getDate());
        countdown.querySelector('[data-ch-days]').textContent = Math.round((finish - start) / 86400000);
      }
      countdown.hidden = false;
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ch-preview]');
    var dialog = document.querySelector('[data-ch-dialog]');
    if (button) {
      if (!dialog || !dialog.showModal) { location.href = button.dataset.url; return; }
      lastTrigger = button;
      dialog.querySelector('#ch-dialog-title').textContent = button.dataset.title;
      dialog.querySelector('[data-ch-dialog-price]').textContent = button.dataset.price;
      dialog.querySelector('[data-ch-dialog-link]').href = button.dataset.url;
      var image = dialog.querySelector('[data-ch-dialog-image]');
      image.hidden = !button.dataset.image;
      if (button.dataset.image) { image.src = button.dataset.image; image.alt = button.dataset.title; }
      else image.removeAttribute('src');
      if (!dialog.open) dialog.showModal();
    }
    if (event.target.closest('[data-ch-dialog-close]') && dialog) dialog.close();
    if (event.target === dialog && dialog) { var bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); }
    var thumb = event.target.closest('[data-ch-thumbnail]');
    if (thumb) {
      var gallery = thumb.closest('[data-ch-gallery]'), main = gallery.querySelector('[data-ch-gallery-image]');
      if (main) { main.src = thumb.dataset.chThumbnail; main.alt = thumb.dataset.alt || ''; }
      gallery.querySelectorAll('[data-ch-thumbnail]').forEach(function (t) { t.setAttribute('aria-pressed', String(t === thumb)); });
    }
    var mood = event.target.closest('[data-ch-mood]');
    if (mood) {
      var atmosphere = mood.closest('[data-ch-atmosphere]'); atmosphere.dataset.mood = mood.dataset.chMood;
      atmosphere.querySelectorAll('[data-ch-mood]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === mood)); });
      atmosphere.querySelector('[data-ch-mood-copy]').textContent = mood.dataset.chMood === 'candlelight' ? atmosphere.dataset.candleCopy : atmosphere.dataset.classicCopy;
    }
    var snow = event.target.closest('[data-ch-snow]');
    if (snow) {
      var on = snow.getAttribute('aria-pressed') !== 'true'; snow.setAttribute('aria-pressed', String(on));
      var flakes = snow.closest('.ch-hero').querySelector('.ch-snow'); flakes.hidden = !on || reduced.matches;
      snow.firstChild.textContent = on ? 'Pause the snow ' : 'Let it snow ';
    }
    if (event.target.closest('[data-ch-top]')) window.scrollTo({ top: 0, behavior: reduced.matches ? 'auto' : 'smooth' });
  });
  document.addEventListener('close', function (event) { if (event.target.matches('[data-ch-dialog]') && lastTrigger && lastTrigger.isConnected) lastTrigger.focus(); }, true);
  var scrollQueued = false;
  window.addEventListener('scroll', function () {
    if (scrollQueued) return; scrollQueued = true;
    requestAnimationFrame(function () { document.querySelectorAll('[data-ch-top]').forEach(function (b) { b.classList.toggle('is-visible', window.scrollY > 650); }); scrollQueued = false; });
  }, { passive: true });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { sliders.forEach(function (cleanup, element) { if (event.target.contains(element)) { cleanup(); sliders.delete(element); } }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
})();
